export default __webpack_public_path__ + "static/media/mailBlack.13a9cc7e.svg";